import client from './client'
import { GetAddressResponse } from './types'

export * from './types'

export const getAddress = async (postalCode: string) => {
  const [first, second] = postalCode.includes('-')
    ? postalCode.split('-')
    : [postalCode.substring(0, 3), postalCode.substring(3)]

  const res: GetAddressResponse = await client.get(`/${first}/${second}.json`)
  return res
}
